var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPawVetSecondary = function SvgPawVetSecondary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2851 10.7146C9.09626 10.7146 4.60729 15.6443 4.60729 18.758C4.57194 20.1602 5.64627 20.9999 7.45583 20.9999C9.41647 20.9999 10.7142 19.9914 12.2851 19.9914C13.8721 19.9914 15.1738 20.9999 17.1144 20.9999C18.8862 20.9999 19.9967 20.161 19.9967 18.76C19.9629 15.6483 15.4751 10.7146 12.2851 10.7146Z",
    fill: "#FF7342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.37105 10.2085C5.95441 8.81756 4.66353 7.91358 3.49358 8.19482C2.32363 8.47605 1.71438 9.83082 2.13118 11.2209C2.54781 12.6151 3.8387 13.5191 5.00865 13.2378C6.1786 12.9566 6.78487 11.5986 6.37105 10.2085ZM9.77403 9.3728C11.0143 9.04637 11.637 7.40012 11.1601 5.62149C10.6832 3.84285 9.29191 2.76491 8.04683 3.05539C6.80656 3.38182 6.18382 5.02807 6.66072 6.8067C7.13843 8.54918 8.52855 9.70225 9.77403 9.3728ZM21.0798 8.19562C19.9099 7.95054 18.619 8.81836 18.2023 10.2093C17.7857 11.6006 18.3932 12.9562 19.5631 13.2374C20.7331 13.4825 22.0187 12.6147 22.4406 11.2238C22.8556 9.83082 22.2128 8.47686 21.0798 8.19562ZM14.7961 9.3728C16.0055 9.69924 17.4326 8.54918 17.9095 6.8067C18.3864 5.06423 17.7638 3.38162 16.5233 3.05539C15.314 2.72895 13.8869 3.87901 13.41 5.62149C12.9319 7.36396 13.5547 9.04737 14.7961 9.3728Z",
    fill: "#FF7342"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPawVetSecondary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paw-vet-secondary.bc058c30.svg";
export { ForwardRef as ReactComponent };